import React, { HTMLAttributes, ReactElement, ReactNode, RefObject } from 'react';
import clsx from 'clsx';

import { HelpText } from './HelpText';
import { Label } from './Label';
import styles from './form-item.module.css'
import { ErrorMessage } from './ErrorMessage';

export type FormItemProps = HTMLAttributes<HTMLDivElement> & {
  id?: string,
  label?: string | ReactNode,
  labelIcon?: ReactElement,
  labelType?: 'span' | 'label',
  hideLabel?: boolean,
  hideOptionnal?: boolean,
  required?: boolean,
  inline?: boolean,
  className?: string
  helpText?: React.ReactNode,
  errorText?: React.ReactNode,
  ref?: RefObject<HTMLDivElement | null>
}

export const FormItem = ({
  inline = false,
  label, labelIcon,
  labelType,
  hideLabel,
  hideOptionnal,
  id,
  required = false,
  helpText,
  errorText,
  className,
  children,
  ...props
}: FormItemProps) => {

  return (
    <div className={clsx(styles.item, className)} {...props}>
      <div className={clsx(styles.wrapper, inline && styles.inline)}>
        {label ? <Label label={label} labelIcon={labelIcon} id={id} type={labelType} hideLabel={hideLabel} hideOptionnal={hideOptionnal} required={required}/> : null}
        {children}
      </div>
      {helpText && (
        <HelpText>
          {helpText}
        </HelpText>
      )}
      {errorText && (
        <ErrorMessage>
          {errorText}
        </ErrorMessage>
      )}
    </div>
  )
};
